import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type ShapeAnnotation = {
  id?: string
  parentId?: string | null
  featureId: string
  class: string
  tool: 'bounding_box' | 'keypoint'
  mediaId?: string
  color?: string
  vertices: {
    x: number
    y: number
  }[]
}

type Classification = {
  id?: string
  parentId?: string | null
  featureId: string
  name: string
  description: string
  tool: 'single_choice_classification' | 'multi_choice_classification'
  options: {
    value: string
    default: boolean
    exampleMediaIds: string[]
  }[]
  values: string[]
  mediaId: string
}

type Annotation = ShapeAnnotation | Classification

type EngagementDetails = {
  dateCreated: string
  response: string
  timeToClose: number
  media: { location: string; mediaId: string }[]
  annotations: Annotation[]
  hasEscalated?: boolean
  escalationReason?: string | null
}

type TrainingModuleReviewDetails = {
  request: EngagementDetails
  response: EngagementDetails
  groundTruth: EngagementDetails
}

export const useGetTrainingModuleReviewDetails = (engagementId?: string, sessionId?: string) => {
  return useQuery({
    queryKey: ['training-module-review-details', engagementId, sessionId],
    queryFn: async () => {
      const { data } = await apiClient.get<TrainingModuleReviewDetails>(
        `int/v3/operators/training-review/details/`,
        {
          params: { engagementId, sessionId },
        }
      )

      return data
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(engagementId && sessionId),
  })
}
